import React from 'react';
import { ArrowRight, ClipboardCheck, CheckCircle } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';
import { Button } from './ui/button';

const AssessmentIntroScreen = ({ language, onStart }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-500 to-blue-700 px-8 py-12 text-white text-center">
              <div className="flex justify-center mb-4">
                <div className="w-20 h-20 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                  <ClipboardCheck className="h-10 w-10 text-white" />
                </div>
              </div>
              <h1 className="text-3xl font-bold mb-2">
                {language === 'nl' ? 'AI for HR Quickscan' : 'AI for HR Quickscan'}
              </h1>
              <p className="text-blue-100 text-lg">
                {language === 'nl'
                  ? 'Ontdek hoe AI-klaar uw HR-organisatie is'
                  : 'Discover how AI-ready your HR organization is'}
              </p>
            </div>

            {/* Content */}
            <div className="p-8">
              <div className="space-y-6">
                <p className="text-gray-600 leading-relaxed">
                  {language === 'nl'
                    ? 'Deze quickscan helpt u inzicht te krijgen in de AI-maturiteit van uw HR-organisatie. De vragen zijn ontworpen om u te prikkelen en te informeren, niet om te intimideren.'
                    : 'This quickscan helps you gain insight into the AI for HR of your HR organization. The questions are designed to engage and inform you, not to intimidate.'}
                </p>

                <div className="flex justify-center">
                  <div className="bg-blue-50 rounded-xl p-4 text-center px-8">
                    <div className="text-3xl font-bold text-blue-500">~4</div>
                    <div className="text-sm text-gray-600">
                      {language === 'nl' ? 'Minuten' : 'Minutes'}
                    </div>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <h3 className="font-semibold text-gray-900 mb-3">
                    {language === 'nl' ? 'Wat we meten:' : 'What we measure:'}
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-600">
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-green-500" />
                      <span>{language === 'nl' ? 'Mensen & Change - Is uw team klaar?' : 'People & Change - Is your team ready?'}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-green-500" />
                      <span>{language === 'nl' ? 'Governance - Hebt u het juiste kader?' : 'Governance - Do you have the right framework?'}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-green-500" />
                      <span>{language === 'nl' ? 'Strategie - Is AI verankerd in uw visie?' : 'Strategy - Is AI embedded in your vision?'}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <CheckCircle className="h-4 w-4 text-green-500" />
                      <span>{language === 'nl' ? 'Technologie & Data - Zijn de fundamenten op orde?' : 'Technology & Data - Are the fundamentals in order?'}</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6 border border-blue-200">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center">
                      <CheckCircle className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">
                        {language === 'nl' ? 'Direct starten, geen registratie nodig' : 'Start directly, no registration needed'}
                      </h4>
                      <p className="text-sm text-gray-600">
                        {language === 'nl'
                          ? 'Vul eerst de vragen in en ontvang daarna uw gepersonaliseerde benchmarkrapport'
                          : 'Answer the questions first, then receive your personalized benchmark report'}
                      </p>
                    </div>
                  </div>
                </div>

                <Button
                  onClick={onStart}
                  className="w-full bg-blue-500 hover:bg-blue-600 py-6 text-lg"
                  data-testid="assessment-start-btn"
                >
                  {language === 'nl' ? 'Start Direct met de Quickscan' : 'Start the Quickscan Now'}
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>

                <p className="text-xs text-gray-500 text-center">
                  {language === 'nl'
                    ? 'Door te starten gaat u akkoord met onze privacyverklaring.'
                    : 'By starting, you agree to our privacy policy.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AssessmentIntroScreen;
